import { Filter } from "../types/filter";

export const getRecordsSearchRequestFilters = (searchRequest, searchFieldNameVsFieldMap) => {
  let filters = [];

  for (let key in searchRequest) {
    if (typeof searchFieldNameVsFieldMap[key] == "undefined" || searchRequest[key] == null || searchRequest[key] === "") {
      continue;
    }
    if (searchFieldNameVsFieldMap[key].foreignEntityType || searchFieldNameVsFieldMap[key].type === "rawSearch") {
      //handled by separate function, to clean up and combine
      continue;
    }
    if (searchFieldNameVsFieldMap[key].type === "text") {
      filters.push({
        filters: [],
        field: key,
        values: [searchRequest[key]],
        type: "CONTAINS",
      });
    } else if (searchFieldNameVsFieldMap[key].type === "number") {
      filters.push({
        filters: [],
        field: key,
        values: [searchRequest[key]],
        type: "EQUALS",
      });
    } else {
      filters.push({
        filters: [],
        field: key,
        values: [searchRequest[key]],
        type: "IN",
      });
    }
  }
  return { filters, field: null, values: [], type: "AND" };
};

export const getRecordsSearchParams = (searchRequest, searchFieldNameVsFieldMap): any => {
  let newSearchParams = {};
  for (let key in searchRequest) {
    if (
      typeof searchFieldNameVsFieldMap[key] == "undefined" ||
      searchRequest[key] == null ||
      searchRequest[key] === "" ||
      searchFieldNameVsFieldMap[key].type !== "rawSearch"
    ) {
      continue;
    }
    newSearchParams[key] = searchRequest[key];
  }
  return newSearchParams;
};

export const getRecordsSearchRequestForeignFilters = (searchRequest, searchFieldNameVsFieldMap): Map<string, Filter> => {
  let filters = new Map<string, Filter[]>();

  for (let key in searchRequest) {
    if (typeof searchFieldNameVsFieldMap[key] == "undefined" || searchRequest[key] == null || searchRequest[key] === "") {
      continue;
    }
    if (!searchFieldNameVsFieldMap[key].foreignEntityType) {
      //handled by separate function, to clean up and combine
      continue;
    }
    if (searchFieldNameVsFieldMap[key].type === "text") {
      filters.set(searchFieldNameVsFieldMap[key].foreignEntityType, [
        ...(filters.get(searchFieldNameVsFieldMap[key].foreignEntityType) || []),
        {
          field: key,
          values: [searchRequest[key]],
          type: "CONTAINS",
        },
      ]);
    } else if (searchFieldNameVsFieldMap[key].type === "number") {
      filters.set(searchFieldNameVsFieldMap[key].foreignEntityType, [
        ...(filters.get(searchFieldNameVsFieldMap[key].foreignEntityType) || []),
        {
          field: key,
          values: [searchRequest[key]],
          type: "EQUALS",
        },
      ]);
    } else {
      filters.set(searchFieldNameVsFieldMap[key].foreignEntityType, [
        ...(filters.get(searchFieldNameVsFieldMap[key].foreignEntityType) || []),
        {
          field: key,
          values: [searchRequest[key]],
          type: "IN",
        },
      ]);
    }
  }

  let combinedFilters = new Map<string, Filter>();
  for (let [foreignEntityType, entityFilters] of Array.from(filters)) {
    combinedFilters.set(foreignEntityType, { filters: entityFilters, type: "AND" });
  }
  return combinedFilters;
};
